import { render, staticRenderFns } from "./DeleteAccountModal.vue?vue&type=template&id=2a95641d&scoped=true&"
import script from "./DeleteAccountModal.vue?vue&type=script&lang=js&"
export * from "./DeleteAccountModal.vue?vue&type=script&lang=js&"
import style0 from "./DeleteAccountModal.vue?vue&type=style&index=0&id=2a95641d&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a95641d",
  null
  
)

export default component.exports